import React from "react";
import { TermsOfServicePage } from "@v2/components/policies/terms";

export default function TermsOfService() {
    return <TermsOfServicePage />;
}
